function helperGetDateTime (date) {
  return date.getTime()
}

module.exports = helperGetDateTime
